module.exports = __webpack_public_path__ + "img/01.MRO_logotipo_principal.7c1dc378.png";